import { render, staticRenderFns } from "./PayeeInputGrid.vue?vue&type=template&id=09056c96"
import script from "./PayeeInputGrid.vue?vue&type=script&lang=js"
export * from "./PayeeInputGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports